import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { formatApiError } from "@/lib/api";

export default function Profile() {
  const { user, updateProfile } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "", phone: user?.phone || "", gender: user?.gender || "",
    dob: user?.dob || "", address: user?.address || "", emergency_contact: user?.emergency_contact || "",
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try { await updateProfile(form); toast.success("Profile updated"); }
    catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl space-y-6">
      <h1 className="text-3xl font-bold text-slate-900">Profile</h1>
      <form onSubmit={save} className="doccare-card p-6 space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>Full name</Label><Input value={form.name} onChange={set("name")} className="mt-1.5 rounded-xl h-11" data-testid="prof-name" /></div>
          <div><Label>Email</Label><Input value={user?.email || ""} disabled className="mt-1.5 rounded-xl h-11 bg-slate-50" /></div>
          <div><Label>Phone</Label><Input value={form.phone} onChange={set("phone")} className="mt-1.5 rounded-xl h-11" data-testid="prof-phone" /></div>
          <div><Label>Date of birth</Label><Input type="date" value={form.dob} onChange={set("dob")} className="mt-1.5 rounded-xl h-11" data-testid="prof-dob" /></div>
          <div><Label>Gender</Label><Input value={form.gender} onChange={set("gender")} placeholder="male / female / other" className="mt-1.5 rounded-xl h-11" data-testid="prof-gender" /></div>
          <div><Label>Emergency contact</Label><Input value={form.emergency_contact} onChange={set("emergency_contact")} className="mt-1.5 rounded-xl h-11" data-testid="prof-emergency" /></div>
        </div>
        <div><Label>Address</Label><Input value={form.address} onChange={set("address")} className="mt-1.5 rounded-xl h-11" data-testid="prof-address" /></div>
        <div className="pt-2">
          <Button type="submit" disabled={saving} className="rounded-xl" data-testid="prof-save">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save changes"}
          </Button>
        </div>
      </form>
    </div>
  );
}
